if (!window.customElements.get('quantity-selector')) {
  class QuantitySelector extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productBuyBox = this.closest('product-buy-box');
      this.productBuyBoxQuantityInputs = this.productBuyBox?.querySelectorAll('input[name="quantity"]');
      this.quantityInput = this.querySelector('[data-quantity-input]');
      this.quantityActions = this.querySelectorAll('[data-action]');
      this.plusButton = this.querySelector('[data-action="add"]');
      this.controlsLocked = false;
      this.limitMessage = this.parentElement?.querySelector('[data-item-limit-reached]') || null;

      this.boundUpdateQuantity = this.updateQuantity.bind(this);

      this.quantityActions.forEach((action) => {
        action.addEventListener('click', this.boundUpdateQuantity);
      });

      this.updateButtonStates();
    }

    disconnectedCallback() {
      this.quantityActions.forEach((action) => {
        action.removeEventListener('click', this.boundUpdateQuantity);
      });
    }

    updateBuyBoxQuantity() {
      if (this.quantityInput && this.productBuyBox) {
        this.productBuyBoxQuantityInputs.forEach((buyBoxQuantityInput) => {
          buyBoxQuantityInput.value = this.quantityInput.value;
        });
      }
    }

    updateButtonStates() {
      if (!this.quantityInput || !this.plusButton) return;
      const value = parseInt(this.quantityInput.value, 10) || 0;
      const max = parseInt(this.quantityInput.getAttribute('max'), 10);
      const atMax = Number.isFinite(max) && value >= max;
      this.plusButton.disabled = atMax;

      if (this.limitMessage) {
        this.limitMessage.classList.toggle('hidden', !atMax);
      }
    }

    // Lock both controls while a quantity update is in flight so the user
    // can't queue further add/remove actions and desync from the request.
    setControlsDisabled(disabled) {
      this.controlsLocked = disabled;

      this.quantityActions.forEach((action) => {
        action.disabled = disabled;
      });

      if (!disabled) {
        this.updateButtonStates();
      }
    }

    updateQuantity(e) {
      const action = e.currentTarget.dataset.action;

      if (!action) {
        return;
      } else if (action === 'add') {
        const newValue = parseInt(this.quantityInput.value) + 1;
        const maxQuantity = parseInt(this.quantityInput.getAttribute('max') || 10000);

        if (newValue <= maxQuantity) {
          this.quantityInput.value++;
        }
      } else {
        if (this.quantityInput.value > 1) {
          this.quantityInput.value--;
        } else {
          this.quantityInput.dispatchEvent(new Event('minusOnZero'));
          return;
        }
      }

      this.updateBuyBoxQuantity();
      this.updateButtonStates();
      this.quantityInput.dispatchEvent(new Event('change'));
    }
  }

  window.customElements.define('quantity-selector', QuantitySelector);
}
